import React, { useState } from 'react'
import { SearchableSelectBase } from 'components'
import { useShippingMethodsOptions } from '../../hooks'

type Props = {
  disabled?: boolean
  onSelect: (selectOption: SelectOption) => void
}

const ShippingMethodsSelect = (props: Props) => {
  const [searchText, setSearchText] = useState<string>('')
  const { data, isLoading } = useShippingMethodsOptions(searchText)

  return (
    <SearchableSelectBase
      {...props}
      options={data?.map((item) => ({ id: item.id, name: item.name }))}
      onSearch={(newSearchText: string) => setSearchText(newSearchText)}
      isLoading={isLoading}
    />
  )
}

export default ShippingMethodsSelect
